<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="600px"
  (onClose)="onCancel()"
>
  <div
    slot="children"
    *transloco="let t; read: 'configuration-query-topics-purpose-dialog-component'"
  >
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div class="xi-modal__container configuration-query-topics-purpose-dialog__container">
          <h2 class="xi-modal__title">
            @if (initialized) {
              {{ t('edit') }}
              @if (hasPurposeGenerationPermission) {
                {{ t('generate') }}
              }
            }
            {{ t('description') }}
          </h2>

          <div class="xi-modal__content" [formGroup]="formGroup">
            <xi-text-area
              formControlName="longPurpose"
              (keydown)="$event.stopPropagation()"
            ></xi-text-area>
          </div>

          <div class="xi-modal__actions configuration-query-topics-purpose-dialog__actions">
            <xi-default-button
              type="button"
              text="{{ t('cancel') }}"
              fill="text"
              (onClick)="onCancel()"
            ></xi-default-button>

            <div class="configuration-query-topics-purpose-dialog__actions--right">
              @if (isGenerationInProgress) {
                <xi-animation
                  [height]="75"
                  [width]="75"
                  [loop]="true"
                  animation="cx_loader"
                ></xi-animation>
              }
              @if (hasPurposeGenerationPermission) {
                <xi-default-button
                  text="{{ t('regenerate-with-gpt') }}"
                  fill="outline"
                  iconLeft="star"
                  [disabled]="isGenerationInProgress || formGroup.invalid"
                  (onClick)="onGenerate()"
                ></xi-default-button>
              }
              <xi-default-button
                text="{{ t('save') }}"
                [disabled]="isGenerationInProgress || formGroup.invalid"
                (onClick)="onSave()"
              ></xi-default-button>
            </div>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
